import { auth, lead, dealer, carView, carList, support, communications, airWeb, fleetManagers, tickets, serviceManagers } from '.';

//Rollbar is a global variable, lint complains
//https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-global-variables
//const Rollbar = window.Rollbar;

const api = (action, ...params) => {
  const apis = {
    login: auth.login,
    currentUser: auth.currentUserPoolUser,
    completeNewPassword: auth.completeNewPassword,
    changePassword: auth.changePassword,
    forgotPassword: auth.forgotPassword,
    forgotPasswordSubmit: auth.forgotPasswordSubmit,
    leadsSummary: lead.summary,
    leadsStatusSummary: lead.statusSummary,
    getLeads: lead.get,
    'get dealer vehicle summary': dealer.getDealerVehicleSummary,
    'dealer profile': dealer.get,
    'getAllDealers': dealer.getAll,
    getAlarms: carView.getAlarms,
    getAlarmsHistory: carView.getAlarmsHistory,
    getCar: carView.getCar,
    getDtcs: carView.getDtcs,
    getDtcsHistory: carView.getDtcsHistory,
    getLead: carView.getLead,
    getLeadHistory: carView.getLeadHistory,
    getMaintenances: carView.getMaintenances,
    getMaintenancesCarHistory: carView.getMaintenancesCarHistory,
    sendNote: carView.sendNote,
    getNotesHistory: carView.getNotesHistory,
    'add reservation': lead.addReservation,
    'delete reservation': lead.deleteReservation,
    'update reservation': lead.updateReservation,
    getReservationsHistory: lead.getReservationsHistory,
    'get fidelity': lead.clientFidelity,
    'get all fidelity': lead.clientsFidelity,
    suspendLeads: lead.suspend,
    'send sms': lead.sendSms,
    'send email': lead.sendEmail,
    'client discard': lead.discard,
    'client request action': lead.action,
    supportRequest: support.supportRequest,
    'get cars': carList.get,
    'get cars list': carList.getCars,
    getCarsList: carList.getList,
    getCarsListBadges: carList.getListBadges,
    getCarsFiltersOptions: carList.getFiltersOptions,
    exportCars: carList.export,
    getCommunications: communications.getAll,
    getCommunicationsIncoming: communications.getIncoming,
    setCommunicationsNotified: communications.setNotified,
    setCommunicationsReadByLead: communications.setReadByLead,
    getCommunicationsByLead: communications.getByLead,
    getSystemCommunications: communications.getSystemCreated,
    setCommunicationsRead: communications.setRead,
    setSystemCommunicationsRead: communications.setSystemRead,
    setSystemCommunicationsReadById: communications.setSystemReadById,
    setSystemCommunicationsManyReadByIds: communications.setSystemManyReadByIds,
    getCommunicationsHistory: communications.getHistory,
    'airweb token': airWeb.token,
    'set shutdown': carView.setShutdown,
    'get car config': carView.getConfig,
    getCarBatteryLevelHistory: carView.getBatteryLevelHistory,
    confirmMaintenances: carView.confirmManagedMaintenances,
    closeLead: carView.closeLead,
    openLead: carView.openLead,
    'exportLeadLifeCycle': carView.exportLeadLifeCycle,
    addMaintenance: carView.addMaintenance,
    'set obd service': carView.setObdService,
    deleteCar: carView.deleteCar,
    getFleetManagers: fleetManagers.getAll,
    createFleetManager: fleetManagers.create,
    updateFleetManager: fleetManagers.update,
    getAvailableAssets: fleetManagers.getAvailableAssets,
    getFleetManagerAssets: fleetManagers.getFleetManagerAssets,
    assignFleetManagerAssets: fleetManagers.assignFleetManagerAssets,
    unassignFleetManagerAssets: fleetManagers.unassignFleetManagerAssets,
    getAvailableAssetsWithActiveLead: serviceManagers.getAvailableAssetsWithActiveLead,
    getServiceManagerAssets: serviceManagers.getServiceManagerAssets,
    assignServiceManagerAssets: serviceManagers.assignServiceManagerAssets,
    unassignServiceManagerAssets: serviceManagers.unassignServiceManagerAssets,
    getTicketTypes: carView.getTicketTypes,
    getTicketStatuses: carView.getTicketStatuses,
    getTickets: tickets.getTickets,
    getTicketsCarHistory: tickets.getTicketsCarHistory,
    createTicket: tickets.createTicket,
    hasOpenTickets: tickets.hasOpenTickets,
    getTicket: tickets.getTicket,
    createTicketComment: tickets.createTicketComment,
    createTicketFile: tickets.createTicketFile,
    getTicketDefaultFilters: tickets.getDefaultFilters,
    getTicketCarFilters: tickets.getTicketCarFilters,
    'launch dtc full scan': carView.launchFullScan,
    'get dtc full scan status': carView.getFullScanStatus,
    getServiceManagers: serviceManagers.getAll,
    createServiceManager: serviceManagers.create,
    updateServiceManager: serviceManagers.update
  };

  try {
    return apis[action](...params);
  } catch (error) {
    console.error(`action: ${action} - error: ${error}`);
    //Rollbar.error(error);
    return Promise.reject(Object.assign({}, error, { severity: 'high' }));
  }
};

export default api;
